// Listens for `okoiya:celebrate` events and shows a soft, auto-dismissing
// love-note card at the top. Mounted once in the dashboard.
import { useEffect, useState, useRef } from 'react'
import { Heart } from 'lucide-react'

export default function CelebrationToast() {
  const [msg, setMsg] = useState(null)
  const timer = useRef(null)

  useEffect(() => {
    function onCelebrate(e) {
      setMsg(e.detail)
      clearTimeout(timer.current)
      timer.current = setTimeout(() => setMsg(null), 4600)
    }
    window.addEventListener('okoiya:celebrate', onCelebrate)
    return () => { window.removeEventListener('okoiya:celebrate', onCelebrate); clearTimeout(timer.current) }
  }, [])

  if (!msg) return null

  return (
    <div style={{ position: 'fixed', top: 0, left: 0, right: 0, display: 'flex', justifyContent: 'center', zIndex: 9999, pointerEvents: 'none', padding: '1rem' }}>
      <style>{`@keyframes celebDrop{0%{opacity:0;transform:translateY(-16px) scale(0.96)}100%{opacity:1;transform:none}}`}</style>
      <div onClick={() => setMsg(null)} style={{
        pointerEvents: 'auto', cursor: 'pointer', maxWidth: 380, width: '100%',
        background: 'linear-gradient(135deg,#FFFFFF,#FBF4EE)', border: '1px solid rgba(196,130,106,0.25)',
        borderRadius: '1rem', padding: '0.9rem 1.1rem', boxShadow: '0 16px 44px rgba(122,60,40,0.18)',
        display: 'flex', alignItems: 'center', gap: '0.75rem', animation: 'celebDrop 0.45s cubic-bezier(0.16,1,0.3,1)',
      }}>
        <div style={{ width: 38, height: 38, borderRadius: '50%', flexShrink: 0, background: 'rgba(196,130,106,0.12)', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          <Heart size={18} color="#C4826A" fill="#C4826A" fillOpacity={0.5} />
        </div>
        <div style={{ minWidth: 0 }}>
          {msg.title && <p style={{ fontFamily: 'Gibs, serif', fontWeight: 400, fontSize: '1rem', color: '#1A1A1A', margin: 0, lineHeight: 1.2 }}>{msg.title}</p>}
          {msg.note && <p style={{ fontFamily: 'Nunito Sans, sans-serif', fontSize: '0.8rem', color: '#6B6B6B', margin: '0.15rem 0 0', lineHeight: 1.5 }}>{msg.note}</p>}
        </div>
      </div>
    </div>
  )
}
